import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { SiteControllerSetting_SettingPage_Query } from "./query";

type Props = { hotelID: string };

export const useFetchSiteControllerSetting = ({ hotelID }: Props) => {
	const { data } = useCustomSuspenseQuery(SiteControllerSetting_SettingPage_Query, {
		variables: {
			hotelID,
		},
	});

	return { data };
};
